<template>
  <path
    d="M19 4.00018H5C3.89 4.00018 3 4.90018 3 6.00018V18.0002C3 19.1002 3.89 20.0002 5 20.0002H19C20.1 20.0002 21 19.1002 21 18.0002V6.00018C21 4.90018 20.11 4.00018 19 4.00018ZM18 18.0002H6C5.45 18.0002 5 17.5502 5 17.0002V8.00018H19V17.0002C19 17.5502 18.55 18.0002 18 18.0002Z"
  />
</template>
